// src/pages/personal/analytics/MarketingExpensesPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import MarketingExpensesSection from './MarketingExpensesSection/MarketingExpensesSection';

const MarketingExpensesPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <MarketingExpensesSection />
    </AdaptiveLayout>
  );
};

export default MarketingExpensesPage;